import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint';

import { useCalculatorBasket } from '@/components/modules/caclulator';

import { useTranslate } from '@/shared/hooks/use-translate';
import { ShoppingCardIcon } from '@/shared/ui/icons';
import { priceFormat } from '@/shared/utils/currency';

type TBasketBlockFullHeadProps = {
    count: number;
};

export const BasketBlockFullHead: React.FC<TBasketBlockFullHeadProps> = ({ count }) => {
    const screen = useBreakpoint();

    const { totalPrice } = useCalculatorBasket();

    const { t } = useTranslate();

    return (
        <div className="head">
            {count > 1 && (
                <div className="inf1">
                    {screen.md && (
                        <span>
                            <ShoppingCardIcon />
                        </span>
                    )}
                    {t('Ваша корзина разделена на несколько заказов. Каждый нужно оформить отдельно')}
                </div>
            )}
            <div className="inf2">
                <div>
                    {!screen.md && (
                        <div>
                            <ShoppingCardIcon />
                        </div>
                    )}
                    <div>
                        {t('В корзине')} <span>{count}</span> {t('товара на предварительную сумму')}{' '}
                        <span>{priceFormat(totalPrice)} ₸</span>
                    </div>
                </div>
            </div>
        </div>
    );
};
